import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { PlayerProvider } from "@/context/PlayerContext";
import { SettingsProvider } from "@/context/SettingsContext";
import Header from "@/components/site/Header";
import Footer from "@/components/site/Footer";
import PlayerBar from "@/components/site/CdjPlayerBar";
import { SeoRoute, NoIndex, LabelJsonLd } from "@/components/site/Seo";
import Home from "@/pages/Home";
import Releases from "@/pages/Releases";
import ReleaseDetail from "@/pages/ReleaseDetail";
import Artists from "@/pages/Artists";
import ArtistDetail from "@/pages/ArtistDetail";
import About from "@/pages/About";
import Genres from "@/pages/Genres";
import GenreDetail from "@/pages/GenreDetail";
import { ChatWidget } from "@/components/site/ChatWidget";
import { LaserCursor } from "@/components/site/LaserCursor";
import Services from "@/pages/Services";
import { PaymentSuccess, PaymentCancel, OrderStatus, Terms } from "@/pages/Payments";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function PublicLayout() {
  return (
    <div className="grain min-h-screen flex flex-col">
      <SeoRoute />
      <LabelJsonLd />
      <Header />
      <main className="flex-1 pb-28"><Outlet /></main>
      <Footer />
      <ChatWidget />
      <LaserCursor />
    </div>
  );
}

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen grid place-items-center font-mono-tga text-zinc-500">Caricamento…</div>;
  return user ? children : <Navigate to="/admin/login" replace />;
}

function App() {
  return (
    <AuthProvider>
      <SettingsProvider>
        <PlayerProvider>
          <BrowserRouter>
            <Routes>
              <Route element={<PublicLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/uscite" element={<Releases />} />
                <Route path="/uscite/:id" element={<ReleaseDetail />} />
                <Route path="/artisti" element={<Artists />} />
                <Route path="/artisti/:id" element={<ArtistDetail />} />
                <Route path="/chi-siamo" element={<About />} />
                <Route path="/generi" element={<Genres />} />
                <Route path="/generi/:slug" element={<GenreDetail />} />
                <Route path="/servizi" element={<Services />} />
                <Route path="/pagamento/successo" element={<PaymentSuccess />} />
                <Route path="/pagamento/annullato" element={<PaymentCancel />} />
                <Route path="/ordine/:id" element={<OrderStatus />} />
                <Route path="/termini" element={<Terms />} />
                <Route path="/contatti" element={<Contact />} />
              </Route>
              <Route path="/admin/login" element={<NoIndex><AdminLogin /></NoIndex>} />
              <Route path="/admin" element={<NoIndex><Protected><AdminDashboard /></Protected></NoIndex>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <PlayerBar />
          </BrowserRouter>
          <Toaster theme="dark" position="top-right" />
        </PlayerProvider>
      </SettingsProvider>
    </AuthProvider>
  );
}

export default App;
